import "@carbon/web-components/es/components/accordion/index.js";
import "@carbon/web-components/es/components/button/index.js";
import "@carbon/web-components/es/components/icon-button/index.js";
import "@carbon/web-components/es/components/modal/index.js";
import "@carbon/web-components/es/components/notification/index.js";
import "@carbon/web-components/es/components/overflow-menu/index.js";
import "@carbon/web-components/es/components/select/index.js";
import "@carbon/web-components/es/components/tag/index.js";
import "@carbon/web-components/es/components/text-input/index.js";
import "@carbon/web-components/es/components/tile/index.js";

import ArrowLeft20 from "@carbon/icons/es/arrow--left/20.js";
import ArrowRight20 from "@carbon/icons/es/arrow--right/20.js";
import ChevronDown20 from "@carbon/icons/es/chevron--down/20.js";
import Download20 from "@carbon/icons/es/download/20.js";
import Home20 from "@carbon/icons/es/home/20.js";
import Help20 from "@carbon/icons/es/help/20.js";
import Settings20 from "@carbon/icons/es/settings/20.js";
import Share20 from "@carbon/icons/es/share/20.js";
import UserAvatar20 from "@carbon/icons/es/user--avatar/20.js";
import UserAvatarFilled20 from "@carbon/icons/es/user--avatar--filled/20.js";

import "./app.js";

const icons = {
  "arrow-left": ArrowLeft20,
  "arrow-right": ArrowRight20,
  "chevron-down": ChevronDown20,
  download: Download20,
  help: Help20,
  home: Home20,
  settings: Settings20,
  share: Share20,
  "user-avatar": UserAvatar20,
  "user-avatar-filled": UserAvatarFilled20
};

function createIconNode(definition) {
  const node = document.createElementNS("http://www.w3.org/2000/svg", definition.elem);
  Object.entries(definition.attrs || {}).forEach(([name, value]) => node.setAttribute(name, value));
  (definition.content || []).forEach((child) => node.append(createIconNode(child)));
  return node;
}

document.querySelectorAll("[data-carbon-icon]").forEach((host) => {
  [host.dataset.carbonIcon, host.dataset.carbonIconAlt].filter(Boolean).forEach((iconName, index) => {
    const definition = icons[iconName];
    if (!definition) return;
    const icon = createIconNode(definition);
    icon.classList.add(index === 0 ? "carbon-icon-primary" : "carbon-icon-alt");
    icon.setAttribute("slot", "icon");
    icon.setAttribute("aria-hidden", "true");
    host.append(icon);
  });
});
